import createBrowserHistory from 'history/createBrowserHistory';
import {syncHistoryWithStore} from 'mobx-react-router';

import RootStore from './shared/stores/RootStore';

const browserHistory = createBrowserHistory();
const history = syncHistoryWithStore(browserHistory, RootStore.routing);

export default history;
